import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@abp/ng.core';
import { UserDropdownSelectorComponent } from './components/user-dropdown-selector/user-dropdown-selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { UserPhotoModule } from 'src/ca-shared/user-photo/user-photo.module';
import { BaseSelectorModule } from '../base-selector/base-selector.module';
import { UserPopupSelectorComponent } from './components/user-popup-selector/user-popup-selector.component';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UserListSelectorComponent } from './components/user-list-selector/user-list-selector.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { DepartmentSelectorModule } from '../department-selector/department-selector.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatPaginatorModule } from '@angular/material/paginator';

export { UserDropdownSelectorComponent } from './components/user-dropdown-selector/user-dropdown-selector.component';
export { UserPopupSelectorComponent } from './components/user-popup-selector/user-popup-selector.component';
export { UserListSelectorComponent } from './components/user-list-selector/user-list-selector.component';

@NgModule({
  declarations: [
    UserDropdownSelectorComponent,
    UserPopupSelectorComponent,
    UserListSelectorComponent,
  ],
  imports: [
    CoreModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NgSelectModule,
    MatPaginatorModule,
    UserPhotoModule,
    BaseSelectorModule,
    NgbModalModule,
    InfiniteScrollDirective,
    DepartmentSelectorModule,
    MatDividerModule,
    NgbTooltipModule,
  ],
  exports: [UserDropdownSelectorComponent, UserPopupSelectorComponent, UserListSelectorComponent],
})
export class UserSelectorModule {}
